const productdetailsen = {

description: "Description",
qtyWeight: "Qty Weight",
in: "in",
soldOut: "SOLD OUT",
outOfStock: "Out of Stock",
addToCart: "Add To Cart",
addToOrder: "Add To Order",
qty: "Qty",
available: "available",
category: "Category",
supplier: "Supplier",
countryOfOrigin: "Country of Origin",
shareWithFriends: "Share with friends",
dailyOffer: "Daily Offer",
freshOrganicOffer: "Fresh Organic Food Up To 65% Off",
shopNow: "Shop Now",
information: "Information",
reviews: "Reviews",
unit: "Unit",
stock: "Stock",
noReviews: "No reviews submitted yet"

};

export default productdetailsen;